import { AxiosResponse } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export function requestGetDigioImageVerifyCredentials(data: any):
Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.getDigioImageVerifyCredentials,
    data,
  });
}

export function requestGetDigioKycCredentials(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.getDigioKycCredentials,
    data,
  });
}

export function requestGetAadhaarEsignCredentials(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.getAadhaarEsignCredentials,
    data,
  });
}

export function requestVerifyDigioImageVerification(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.verifyDigioImageVerification,
    data,
  });
}

export function requestVerifyDigioKyc(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.verifyDigioKyc,
    data,
  });
}

export function requestVerifyAadhaarEsign(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.verifyAadhaarEsign,
    data,
  });
}

export function requestSaveUserDeclaration(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.userDeclaration,
    data,
  });
}

export function requestSaveUserSign(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.addSign,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
